import { BitkitBadge, IconWarning } from '@bitrise/bitkit-v2';

const FlakyBadge = () => {
  return (
    <BitkitBadge colorVariant="yellow" icon={IconWarning}>
      Flaky
    </BitkitBadge>
  );
};

export default FlakyBadge;
